import { SkillEffectApplyType } from '../SkillEnums';
import { IBlowDef, IBlowDescription } from './types';
import { ParamReader } from './ParamReader';
import { stats } from './stats';
import { misc } from './misc';
import { dots } from './dots';
import { resources } from './resources';
import { triggers } from './triggers';
import { cc } from './cc';
import { cooldowns } from './cooldowns';
import { markers } from './markers';
import { pdLua } from './pd-lua';
import { pdCustom } from './pd-custom';

export const BlowRegistry: Record<number, IBlowDef> = {
    ...stats,
    ...misc,
    ...dots,
    ...resources,
    ...triggers,
    ...cc,
    ...cooldowns,
    ...markers,
    ...pdLua,
    ...pdCustom,
};

export function getBlowDef(id: number): IBlowDef | undefined {
    return BlowRegistry[id];
}

/** "Burn (42)" — new registry, falling back to "Effect N" when unknown. */
export function blowDisplayName(id: number): string {
    const def = BlowRegistry[id];
    if (def) {
        return `${def.name} (${id})`;
    }
    return `Effect ${id}`;
}

export function describeBlowValue(
    id: number,
    rawValue: string,
    durationMs: number,
    applyType?: SkillEffectApplyType,
): IBlowDescription {
    const def = getBlowDef(id);
    if (!def) {
        return {
            id, name: `Effect ${id}`, known: false, segments: null, parseError: false,
            status: undefined, note: undefined, wikiDesc: undefined,
        };
    }
    let segments = null;
    let parseError = false;
    if (def.describe) {
        try {
            segments = def.describe({
                params: new ParamReader(rawValue),
                raw: rawValue == null ? '' : rawValue,
                durationMs,
                applyType,
            });
        } catch (e) {
            segments = null;
            parseError = true;
        }
    }
    return {
        id, name: def.name, known: true,
        status: def.status, note: def.note, wikiDesc: def.wikiDesc,
        segments, parseError,
    };
}
